module.exports = __webpack_public_path__ + "static/media/f5.d3789473.jpg";